import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';

/**
 * "Back" that never leaves the site: goes back in history when the member came from another
 * Carpool page, otherwise to Home (signed in) or the start page (signed out).
 */
export function useSafeBack(): () => void {
  const navigate = useNavigate();
  const { isAuthenticated } = useEnrichedAuth();
  return useCallback(() => {
    let idx = 0;
    try {
      idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    } catch {
      idx = 0;
    }
    if (idx > 0) navigate(-1);
    else navigate(isAuthenticated ? '/home' : '/', { replace: true });
  }, [navigate, isAuthenticated]);
}
